import React from 'react'
import { observer } from "mobx-react";
import { useStores } from "../../stores/rootStore";
/* import { EmployeeReviewActions } from 'src/stores/models/enums'; */
import { Button, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { QARFormSave } from './save';


export const QARFormFooter = observer(() => {

  const { qarFormStore } = useStores();

  // function handleReset() {

  //   async function fetchEmployees() {
  //     await qarFormStore.loadEmployees(qarFormStore.selectedManagerId!);
  //     await qarFormStore.loadDelegatedUnmatchedAccounts(qarFormStore.selectedManagerId!);
  //   }

  //   fetchEmployees();
  // }

  const renderQuarterInformation = () => {
    if (qarFormStore.employees === undefined || qarFormStore.selectedQuarter === undefined) {
      return (
        <>
          <Skeleton variant="text" width="50%" style={{ margin: "10px 0" }} />
          <Skeleton variant="text" width="40%" style={{ margin: "10px 0" }} />
          <Skeleton variant="text" width="30%" style={{ margin: "10px 0" }} />
          <Skeleton variant="text" width="30%" style={{ margin: "10px 0" }} />
        </>
      );
    }


    /*     const employeeAccountsCount = qarFormStore.employees.flatMap(x => x.accounts).length;
        const delegatedUnmatchedAccountsCount = qarFormStore.delegatedUnmatchedAccounts?.flatMap(x => x.accounts).length; */
    /*     const allAccountsCount = employeeAccountsCount + delegatedUnmatchedAccountsCount!;
    
        const completedEmployeeAccountsCount = qarFormStore.employees.flatMap(x => x.accounts).filter(account => {
          return account.action.name !== EmployeeReviewActions.MissingAction;
        }).length; */

    return (
      <>
        <Typography component="p" align='left'>
          <span className="deadline">Review {qarFormStore.selectedQuarter.isManagerReviewAdminCompleted ? " was " : " is "} due on <b>{new Date(qarFormStore.selectedQuarter.reviewDeadline).toUTCString()}</b> ({new Date(qarFormStore.selectedQuarter.reviewDeadline).toLocaleString()} local time).</span><br />
          Created on {new Date(qarFormStore.selectedQuarter.createdAt).toUTCString()} ({new Date(qarFormStore.selectedQuarter.createdAt).toLocaleString()} local time).<br />
          {/*         Reviewed {completedEmployeeAccountsCount} accounts out of {allAccountsCount}.<br/>
        {qarFormStore.isCompleted ?
          <span>You have completed your review.</span> :
          <span>You have <b>not</b> completed your review.</span>
        } */}
        </Typography>
      </>
    );
  }

  // const renderResetButton = () => {

  //   if(qarFormStore.selectedQuarter?.isManagerReviewAdminCompleted){
  //     return <></>
  //   }

  //   if (!qarFormStore.employees) {
  //     return (<Skeleton variant="rect" width={150} height={30} />);
  //   }

  //   return (
  //     <Button variant="contained" color="default" onClick={handleReset} className="resetForm">Reset</Button>
  //   );
  // }

  return (
    <span className="mfooter">
      {renderQuarterInformation()}
      {/* {renderResetButton()} */}
      <QARFormSave></QARFormSave>
    </span>
  );

});